export const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  ADMIN: 'Admin',
  PROFESSIONAL: 'Professional',
};

export const PERMISSIONS = {
  MANAGE_USERS: 'manage_users',
  VIEW_DASHBOARD: 'view_dashboard',
  MANAGE_SETTINGS: 'manage_settings',
  VIEW_ADMINS: 'view_admins',
};

export const ROLE_PERMISSIONS = {
  [ROLES.PROFESSIONAL]: [PERMISSIONS.VIEW_DASHBOARD],
  [ROLES.ADMIN]: [PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.MANAGE_USERS],
};

export const hasPermission = (role, permission) => {
  if (!role) {
    return false;
  }

  if (role === ROLES.SUPER_ADMIN) {
    return true;
  }

  const permissions = ROLE_PERMISSIONS[role] ?? [];
  return permissions.includes(permission);
};
